var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationesS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16C8.10457 16 9 15.1046 9 14H5C5 15.1046 5.89543 16 7 16Z",
    fill: "#0e2238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99516 1.09903C7.99836 1.06646 8 1.03342 8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1C6 1.03342 6.00164 1.06646 6.00484 1.09904C3.7202 1.56045 2.00002 3.57934 2.00002 6C2.00002 7.0976 1.5 12 0 13H14C12.5 12 12 7.0976 12 6C12 3.57932 10.2798 1.56042 7.99516 1.09903Z",
    fill: "#0e2238"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationesS);
export default __webpack_public_path__ + "static/media/notificationesS.9b420b6eb18e2b238f30684296fa90c4.svg";
export { ForwardRef as ReactComponent };